import React, { createRef } from 'react';
import styled from 'styled-components';
import GoodDesc from './GoodDesc';
import { goodpageText } from '../../Lang/fa/Goodpage';
import GoodQuestions from './GoodQuestions';
import GoodComments from './GoodComments';

const Styles = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: calc(100% - var(--width-padding));
    padding: 2rem var(--padding);
    gap: 1.25rem;
    .nav {
        position: sticky;
        top: 110px;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        background-color: var(--body-2);
        border-radius: var(--border-radius-9);
        z-index: 3;
        transition: all 0.15s ease-in-out;
        &.hide {
            top: 60px;
        }
        .item {
            cursor: pointer;
            color: var(--gray-6);
            font-size: 0.87rem;
            font-weight:600;
            margin: 0 2.6rem 0 1rem;
            padding: 2.6rem 0 2.2rem;
            align-items:right;
            display: flex;
            transition: all 0.2s ease-in-out;

            /* :hover {
                box-shadow: 0 5px 10px -2px #888;
            } */
        }
        .selected {
            color:var(--primary-5);
            border-bottom: 3px solid var(--primary-5);
            border-radius: var(--border-radius-9) var(--border-radius-9) 0px 0px;
        }
    }
    .good-body {
        background-color: var(--body-2);
        border-radius: var(--border-radius-9);
        padding: 2.5rem ;
        width: calc(100% - 5rem);
        max-height: 32rem;
        overflow: hidden;
        position: relative;
        &.more{
            max-height: max-content;
        }
        
        .more-row{
            width:100% ;
            background-color: var(--body-2);
            padding: 1rem 0;
            position: absolute;
            bottom: 0;
            right: 0;
            height: max-content;
            display: flex;
            border-radius:0 0  var(--border-radius-9) var(--border-radius-9);
            .more-btn{
                margin: 0 2.5rem;
            }
        }
        .desc-tit{
            font-size: 1.2rem;
            font-weight: 500;
        }
        .description{
            font-size: 1rem;
            font-weight: 400;
            line-height:normal;
            padding-bottom: 1rem;
        }
    }
    .none-bg{
        background: none;
        padding: 0 ;
        width: 100%;
        max-height: inherit;
        .section-head{
            background: var(--body-2);
            border-radius: var(--border-radius-9);
            padding:1.5rem 2.5rem ;
            width: calc(100% - 5rem);
            font-size: 1.2rem;
            color: var(--text-5);
            font-weight: 500;
            margin-bottom: 1.25rem;
        }
    }
    @media screen and (max-width: 850px) {
        .nav {
            top: 0rem;
            display: flex;  
            position :relative ;
            margin:0;
            overflow: auto;
            ::-webkit-scrollbar {
                display: none;
            }     
            .item {
                padding: 0.8rem 0.5rem;
                margin: 0 1.5rem;
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;
                align-items: center;
                width: calc(25% - 1rem);
                text-align: center;
                white-space: nowrap;
            }
        }
        .none-bg{
            .section-head{  
                padding:1rem 1.5rem ;
                width: calc(100% - 3rem);
                margin-bottom:0.75rem;
            }
        }
        .good-body {
            display: flex;
            flex-direction: column;
            overflow-x: auto;
            position: relative;
            background:none;
            padding: 0 ;
            width: 100% ;
            .description{
                border-radius: var(--border-radius-9);
                font-size: 0.8rem;
                background-color: var(--body-2);
                padding: 0 0.5rem;
                width: calc(100% - 1rem) ;
                line-height: 1.5rem !important;
                p{
                    line-height: 1.8rem ;
                }
            }
            .more-row{
                right: 0;
                width: 100%;
                padding: 1rem 0;
                .more-btn{
                    margin: 0 1rem;
                }
            }
        }
    }
`

class GoodBody2 extends React.Component {
    constructor(props) {
        super(props);
        this.refScroll1 = createRef()
        this.refScroll2 = createRef()
        this.refScroll3 = createRef()
        this.refScroll4 = createRef()
        this.descH = createRef()
        this.techH = createRef()
        this.bodyref = createRef()
        this.state = {
            page: 0,
            showImageSlider: false,
            showScore: false,
            imageList: [],
            imageIndex: 0,
            scoreTemp: 0,
            cm:'',
            more1:false,
            more2:false,
            more3:false,
            more4:false,
            showmore1:false,
            showmore2:false,
            sticky:false,
            scrol:0,
            hide:false,
            scroll: 0,
        };
    }
    componentDidMount(){
        window.addEventListener("scroll", this.hideNavGood);
        window.scrollTo({
            top:0 ,
            left: 0,
            behavior: 'smooth'
        });
        let show1 = false
        let show2 = false
        if(this.descH){
            if(this.descH.current){
                let size =this.descH.current.getBoundingClientRect().height 
                if(size > 480){
                    show1 = true
                }
            }
        }
        if(this.techH){
            if(this.techH.current){
                let size = this.techH.current.getBoundingClientRect().height 
                if(size > 480){
                    show2 = true
                }
            }
        }
        
        document.addEventListener('scroll', this.TopActive2);
        this.setState({
            showmore1: show1,
            showmore2: show2
        })
    } 
    componentWillUnmount() {
        document.removeEventListener('scroll', this.TopActive2);
        window.removeEventListener("scroll", this.hideNavGood);
    }
    hideNavGood=(e)=>{
        if(this.state.hoverMenu){
            e.preventDefault();
            return false
        }
        if(!this.props.showFilter){
            const currnetY = window.pageYOffset
            if(((currnetY - this.state.scroll) < -20 && currnetY < this.state.scroll ) || currnetY < 50){
                this.setState({
                    hide:false,
                    scroll: currnetY,
                })
            }
            if(currnetY > this.state.scroll && currnetY > 50){
                this.setState({
                    scroll: currnetY,
                    hide: true
                })
            }
        }else{
            this.setState({
                hide:false
            })
        }
    }
    TopActive2=()=>{
        let top =this.bodyref.current.getBoundingClientRect().top
        if(this.state.scrol === 0){
            this.setState({
                scrol: top +  window.scrollY
            })
        }
        if(window.scrollY > this.state.scrol){
            this.setState({
                sticky :true
            })
        }else{
            this.setState({
                sticky :false
            })
        }
        let getBound2 = this.refScroll2.current.getBoundingClientRect().top <= window.innerHeight/2
        let getBound3 = this.refScroll3.current.getBoundingClientRect().top <= window.innerHeight/2
        let getBound4 = this.refScroll4.current.getBoundingClientRect().top <= window.innerHeight/2
        if(getBound4){
            this.setState({
                page: 3,
            })
        }else if(getBound3){
            this.setState({
                page: 2,
            })
        }else if(getBound2 && this.props.technical){
            this.setState({
                page: 1,
            })
        }else{
            this.setState({
                page: 0,
            })
        }
    }
    makeItShort = (text , count) => {
        if(text.length > count){
            return text.slice(0,count) + '...';
        } else {
            return text
        }
    }
    scrollSeler=(page)=>{
        let top = 160
        if(window.innerWidth < 850){
            top = 100
        }
        if(page === 0){
            window.scrollTo({
                top:this.refScroll1.current.getBoundingClientRect().top + window.scrollY - top,
                behavior:'smooth'
            })
        }else if(page === 1){
            if(this.props.technical){
                window.scrollTo({
                    top: this.refScroll2.current.getBoundingClientRect().top + window.scrollY - top,
                    behavior:'smooth'
                })
            }else{
                window.scrollTo({
                    top: this.refScroll1.current.getBoundingClientRect().top + window.scrollY - top,
                    behavior:'smooth'
                })
            }
        }else if(page === 2){
            window.scrollTo({
                top: this.refScroll3.current.getBoundingClientRect().top + window.scrollY - top,
                behavior:'smooth'
            })
        }else if(page === 3){
            window.scrollTo({
                top: this.refScroll4.current.getBoundingClientRect().top + window.scrollY - top,
                behavior:'smooth'
            })
        }
    }
    ClickedNav = (page) => {
        this.setState({
            page: page,
        })
        this.scrollSeler(page)
    }
    showMore=(num)=>{
        let top = -this.bodyref.current.getBoundingClientRect().y + 600
        if(window.innerWidth < 850){
            top = -this.bodyref.current.getBoundingClientRect().y - this.bodyref.current.offsetTop
        }
        
        if(num === 2){
            if(this.state.more2){
                window.scrollTo({
                    top: top ,
                    behavior:'smooth'
                })
            }
            this.setState({
                more2 : !this.state.more2,
                more1 : false,
            })
        }else{
            if(this.state.more1){
                window.scrollTo({
                    top: top ,
                    behavior:'smooth'
                })
            }
            this.setState({
                more1 : !this.state.more1,
                more2 : false,
            })
        }
    }
    makeNavigation = () => {
        let classes = ['item ','item ' , 'item ' ,'item '];
        classes[this.state.page] = 'item selected';
        let style={padding: (this.state.sticky ? '1.3rem 0 1.1rem' : '')}
        let shadow={boxShadow: (this.state.sticky ? 'var(--shadow-7)' : '') , marginBottom: ((this.state.sticky && window.innerWidth > 850) ? '2.4rem':'')}
        return(
            <div className={"nav " + ((this.state.hide && window.innerWidth > 849) ? "hide" : "")} ref={this.bodyref} style={shadow}>
                <div className={classes[0]} style={style} data-key='0' onClick={() => this.ClickedNav(0)}>
                    {goodpageText.refrence}
                </div>
                {
                    this.props.technical
                    ?
                        <div className={classes[1]} style={style} data-key='1' onClick={() => this.ClickedNav(1)}>
                            {goodpageText.specific}
                        </div>  
                    :''
                }
                <div className={classes[2]} style={style} data-key='2' onClick={() => this.ClickedNav(2)}>
                    {goodpageText.comments}
                </div>  
                <div className={classes[3]} style={style} data-key='3' onClick={() => this.ClickedNav(3)}>
                    {goodpageText.ques}
                </div>  
            </div>
        )
    }
    makeReview = () => {
        let description = this.props.fDesc
        if(!description){
            return (
                <div className="good-body" ref={this.refScroll1}>
                    <div className="description" ref={this.descH}>
                        
                    </div>
                </div>
            );
        }
        
        if(description[0] === '{' || description[0] === '['){
            let textFields = JSON.parse(description)
            
            return (
                <div className={"good-body " + (this.state.more1 ? ' more' : '')} ref={this.refScroll1}>
                    <div className="description" ref={this.descH}>
                        <GoodDesc textFields={textFields}/>
                    </div>
                    { 
                        (this.state.showmore1) ?(
                            <div className='more-row'>
                                <span className='more-home2 more-btn' onClick={()=>this.showMore(1)}>{this.state.more1 ? 'بستن' : "مشاهده بیشتر"}</span>
                            </div>
                        ):''
                    }

                </div>
            );
        } else {
            return (
                <div className={"good-body " + (this.state.more1 ? ' more' : '')} ref={this.refScroll1}>
                    <div className="description" ref={this.descH}>
                        {description}
                    </div>
                    { 
                        (this.state.showmore1) ?(
                            <div className='more-row'>
                                <span className='more-home2 more-btn' onClick={()=>this.showMore(1)}>{this.state.more1 ? 'بستن' : "مشاهده بیشتر"}</span>
                            </div>
                        ):''
                    }
                </div>
            );
        }
    }
    makeTechnical = () => {
        let description = this.props.technical
        if(!description){
            return (
                <div className="good-body" style={{display: 'none'}} ref={this.refScroll2}>
                    <div className="description" ref={this.techH}>
                    </div>
                </div>
            );
        }
        if(description[1] === '{' || description[1] === '['){
            let textFields = JSON.parse(description)
            return (
                <div className={"good-body " + (this.state.more2 ? ' more' : '')} ref={this.refScroll2}>
                    <span className='desc-tit'>{goodpageText.specific}</span>
                    <div className="description" ref={this.techH}>
                        <GoodDesc textFields={textFields}/>
                    </div>
                    {
                        this.state.showmore2 ?( 
                            <div className='more-row'>
                                <span className='more-home2 more-btn' onClick={()=>this.showMore(2)}>{this.state.more2 ? 'بستن' : "مشاهده بیشتر"}</span>
                            </div>    
                         ):""
                    }
                   
                </div>
            );
        } else {
            return (
                <div className={"good-body " + (this.state.more2 ? ' more' : '')} ref={this.refScroll2}>
                    <div className="description" ref={this.techH}>
                        {description}
                    </div>
                    {
                        this.state.showmore2 ?( 
                            <div className='more-row'>
                                <span className='more-home2 more-btn' onClick={()=>this.showMore(2)}>{this.state.more2 ? 'بستن' : "مشاهده بیشتر"}</span>
                            </div>    
                         ):""
                    }
                </div>
            );
        }
    }
    makeCommentGoods=()=>{
        return(
            <div className={"good-body none-bg " + (this.state.more3 ? ' more' : '')} ref={this.refScroll3}>
                <div className='section-head'>{goodpageText.comments}</div>
                <GoodComments {...this.props} code={this.props.code} num={this.state.cm} userAllow={this.props.userAllow} />
            </div>
        )
    }
    makeQuestionGoods=()=>{
        return(
            <div className={"good-body none-bg " + (this.state.more4 ? ' more' : '')} ref={this.refScroll4}>
                <div className='section-head'>{goodpageText.ques}</div>
                <GoodQuestions {...this.props} code={this.props.code} num={this.state.cm} />
            </div>
        )
    }
    render() {
        document.addEventListener('scroll',this.TopActive2);
        return (
            <React.Fragment >
                <Styles>
                    {this.makeNavigation()}
                    {this.makeReview()}
                    {this.makeTechnical()}
                    {this.makeCommentGoods()}
                    {this.makeQuestionGoods()}
                </Styles>
            </React.Fragment>
        )
        
    }
}

export default GoodBody2;